export const defaultHighlightedDates = () => false;
